import React from "react"

export const Twitter = () => (
  <svg
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
  >
    <path
      d="M14.977 1.467a.5.5 0 00-.87-.301 2.559 2.559 0 01-1.226.763A3.441 3.441 0 0010.526 1a3.539 3.539 0 00-3.537 3.541v.44C3.998 4.75 2.4 2.477 1.967 1.325a.5.5 0 00-.916-.048C.004 3.373-.157 5.407.604 7.139 1.27 8.656 2.61 9.864 4.51 10.665 3.647 11.276 2.194 12 .5 12a.5.5 0 00-.278.916C1.847 14 3.55 14 5.132 14h.048c4.861 0 8.8-3.946 8.8-8.812v-.479c.363-.37.646-.747.82-1.236.193-.546.232-1.178.177-2.006z"
      fill="currentColor"
    ></path>
  </svg>
)

export const Telegram = () => (
  <svg
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
  >
    <path
      d="M14.993 1.582a.5.5 0 00-.661-.553l-14 5a.5.5 0 00-.056.918l4 2a.5.5 0 00.501-.031l3.32-2.214L6.11 9.188a.5.5 0 00.113.728l6 4a.5.5 0 00.77-.334l2-12z"
      fill="currentColor"
    ></path>
  </svg>
)

export const Calendar = () => (
  <svg
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 2H12V0h-1v2H4V0H3v2H1.5A1.5 1.5 0 000 3.5v10A1.5 1.5 0 001.5 15h12a1.5 1.5 0 001.5-1.5v-10A1.5 1.5 0 0013.5 2zm-6.476 9.232l3.852-4.403-.752-.658-3.148 3.598-1.622-1.623-.708.708 2.378 2.378z"
      fill="currentColor"
    ></path>
  </svg>
)

export const Envelope = () => (
  <svg
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
  >
    <path
      d="M.5 2.5A1.5 1.5 0 012 1h12a1.5 1.5 0 011.5 1.5v1.208L8 7.926.5 3.708V2.5z"
      fill="currentColor"
    ></path>
    <path
      d="M.5 4.855V12.5A1.5 1.5 0 002 14h12a1.5 1.5 0 001.5-1.5V4.855L8 9.074.5 4.854z"
      fill="currentColor"
    ></path>
  </svg>
)
